'use client';

import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import IosShareIcon from '@mui/icons-material/IosShare';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { alpha, Box, IconButton, Typography, useTheme } from '@mui/material';

import Avatar from '@/components/common/Avatar';
import { colors } from '@/styles/theme';

interface ProfileHeaderProps {
  address: string;
  joinedDate: string;
  views: string;
  avatarUrl?: string | null;
}

const ProfileHeader = ({ address, joinedDate, views, avatarUrl }: ProfileHeaderProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const truncateAddress = (addr: string) => {
    if (!addr) return '';
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 4 }}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: `linear-gradient(135deg, #6366f1 0%, ${colors.accent.purple[500]} 100%)`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {avatarUrl ? (
            <Avatar src={avatarUrl} alt={address} size={80} />
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                background: 'linear-gradient(45deg, #12c2e9, #c471ed, #f64f59)',
              }}
            />
          )}
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Typography variant="h5" fontWeight={700} sx={{ letterSpacing: '-0.02em' }}>
              {address.startsWith('0x') ? truncateAddress(address) : address}
            </Typography>
            <IconButton size="small" sx={{ color: 'text.secondary', p: 0.5 }}>
              <OpenInFullIcon sx={{ fontSize: 18 }} />
            </IconButton>
            <IconButton size="small" sx={{ color: 'text.secondary', p: 0.5 }}>
              <CardGiftcardIcon sx={{ fontSize: 18 }} />
            </IconButton>
            <IconButton size="small" sx={{ color: 'text.secondary', p: 0.5 }}>
              <IosShareIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary">
            Joined {joinedDate} · {views} views
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileHeader;
